import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Card, Container, Alert, Col, Row, Modal } from 'react-bootstrap';
import { firestore } from "../../firebase";
import { useHistory, useParams } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa'

export default function ViewSeller() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [error, setError] = useState("");
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [codigo, setCodigo] = useState("");
    const saveCodigo = useRef("");
    const [nombre, setNombre] = useState("");
    const [notas, setNotas] = useState("");
    const history = useHistory();

    function getSeller() {
        setLoading(true);
        setError("");

        const vendedorQuery = firestore.collection('vendedores').doc(id)
        vendedorQuery.onSnapshot(querySnapshot => {
            if (!querySnapshot.exists) {
                setError("El vendedor no existe");
            } else {
                const data = querySnapshot.data();
                setCodigo(data.codigo);
                saveCodigo.current = data.codigo;
                setNombre(data.nombre);
                setNotas(data.notas);
                setLoading(false);
            }
        })
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!codigo || !nombre) {
            setError("Uno o más campos requeridos no llenados");
            setLoading(false);
            return null;
        }

        const editCodigo = codigo.trim();
        const editNombre = nombre.trim();
        const editNotas = notas.trim();

        setCodigo(editCodigo);
        setNombre(editNombre);
        setNotas(editNotas);

        const duplicatesCodigo = await firestore
        .collection('vendedores')
        .where('codigo', '==', editCodigo)
        .get();

        if (editCodigo !== saveCodigo.current && !duplicatesCodigo.empty) {
            setError("El código del vendedor ya está en uso");
            setLoading(false);
            return null;            
        }

        const newVendedor = {
            codigo: editCodigo,
            nombre: editNombre,
            notas: editNotas
        }

        firestore.collection('vendedores').doc(id).update(newVendedor)
        .then(() => {
            setShowEdit(true);
            setEditing(false);
            saveCodigo.current = editCodigo;
            setLoading(false);
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);
        })
    }

    function handleDelete(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        firestore.collection('vendedores').doc(id).delete()
        .then(() => {
            setShowDelete(false);
            setLoading(false);
            history.push("/sellers");
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setShowDelete(false);
            setLoading(false);
        })
    }

    useEffect(() => {
        getSeller();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        >
            <div className="w-100" style = {{ maxWidth: "500px"}}>
                <h2 className="text-center mt-3 mb-4">Ver Vendedor</h2>
                <Modal show={showEdit} onHide={() => setShowEdit}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se editó el vendedor correctamente
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowEdit(false)}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showDelete} onHide={() => setShowDelete(false)}>
                    <Modal.Header>
                        <Modal.Title>Aviso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Desea borrar el vendedor? Desaparecerá del sistema completamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleDelete}>
                            Aceptar
                        </Button>
                        <Button variant="secondary" onClick={() => setShowDelete(false)}>
                            Cancelar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="vendedor-codigo">
                                    <Form.Label>Código</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={codigo}
                                    onChange={e => setCodigo(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="vendedor-nombre">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={nombre}
                                    onChange={e => setNombre(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="vendedor-notas">
                                    <Form.Label>Notas (opcional)</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={3}
                                    value={notas}
                                    onChange={e => setNotas(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={12}>
                                    <Button className='mx-1' disabled={loading || !editing} type="submit">
                                        Guardar
                                    </Button>
                                    <Button className='mx-1' disabled={loading || !editing} variant="danger"
                                    onClick={() => {setEditing(false); getSeller();}}>
                                        Cancelar
                                    </Button>
                                    <Button className='m-1 py-0 px-1' disabled={loading} variant="link" style={{fontSize: "1.65rem"}}
                                    onClick={() => setEditing(true)}>
                                        <span><FaEdit/></span>
                                    </Button>
                                    <Button className='m-1 py-0 px-1' disabled={loading} variant="link" style={{fontSize: "1.65rem"}}
                                    onClick={() => setShowDelete(true)}>
                                        <span><FaTrashAlt/></span>
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}